
import { Tabs, TabPane, Input } from "element-ui"
import couponItem from "./couponItem.vue"
import couponEmpty from "./couponEmpty"
import { getValidCouponList, getInvalidCouponList, exchangeCoupon } from "@/api/coupon"
import pagination from "@/components/ware-view/pagination"
import couponUsageRules from "@/components/dialog/couponUsageRules.vue"
import couponItemDetail from "@/components/dialog/couponItemDetail.vue"
import { showGlobalMessage } from "@/utils/utils"
import { getLanguage } from "@/plugins/i18n"
import { trackCouponClickEvent } from "@/utils/track"

export default {
  name: "Coupons",
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Input.name]: Input,
    couponItem,
    couponEmpty,
    pagination,
    couponUsageRules,
    couponItemDetail
  },
  data() {
    return {
      lang: "",
      activeTab: "valid",
      couponCode: "",
      validCoupons: [],
      invalidCoupons: [],
      validPageInfo: {
        pageCount: 0,
        pageNum: 1,
        pageSize: 12,
        total: 0
      },
      invalidPageInfo: {
        pageCount: 0,
        pageNum: 1,
        pageSize: 12,
        total: 0
      },
      loading: true,
      loadingInstance: null,
      ruleVisible: false,
      ruleTitle: "",
      ruleContent: "",
      detailVisible: false,
      expandItem: {},
      isReedemSussess: false,
      reedemMessage: ""
    }
  },
  computed: {
    curPageInfoKey() {
      return `${this.activeTab}PageInfo`
    }
  },
  mounted() {
    this.lang = getLanguage()
    this.init()
  },
  methods: {
    startLoading() {
      this.loadingInstance = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
    },
    endLoading() {
      this.loadingInstance && this.loadingInstance.close()
    },
    async init() {
      try {
        this.loading = true
        this.startLoading()
        const curPageInfo = this[this.curPageInfoKey]
        const params = {
          currentPage: curPageInfo.pageNum,
          pageSize: curPageInfo.pageSize
        }
        const curCouponListFunc = this.activeTab === "valid" ? getValidCouponList : getInvalidCouponList
        const { data: res } = await curCouponListFunc({ param: JSON.stringify(params) })

        this.ruleTitle = res.useInstructionsTitle || ""
        this.ruleContent = res.useManual || ""
        const curCoupons = this.activeTab === "valid" ? res.couponVOList || [] : res.couponVOListInvalid || []
        curCoupons.forEach(item => {
          this.$set(item, "disabled", this.activeTab !== "valid")
          this.$set(item, "isExpand", false)
        })
        this[`${this.activeTab}Coupons`] = curCoupons

        const total = res.count || 0
        this[this.curPageInfoKey] = {
          pageCount: Math.ceil(total / curPageInfo.pageSize),
          pageNum: res.currentPage || 1,
          pageSize: 12,
          total
        }
        console.log("getCouponList==>", res)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.endLoading()
      }
    },
    handleTabClick(tab) {
      console.log("handleTabClick", tab.name, this.activeTab)
      this.handlePageChange()
    },
    handlePageChange(value = 1) {
      this[this.curPageInfoKey].pageNum = value
      this.init()
    },
    async handleReedem() {
      if (!this.couponCode) return
      trackCouponClickEvent(this.couponCode)
      try {
        this.startLoading()
        const { data: res } = await exchangeCoupon({ param: JSON.stringify({ promoCode: this.couponCode }) })
        console.log("exchangeCoupon", res)
        if ("code" in res) {
          this.reedemMessage = res.result
          this.isReedemSussess = false
        } else {
          this.reedemMessage = this.$t("coupon.reedemMessage")
          this.isReedemSussess = true
          this.handlePageChange()
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.endLoading()
        this.couponCode = ""
      }

      this.showMessage()
    },
    showMessage() {
      this.$nextTick(() => {
        const gap = 98
        const iconClass = this.isReedemSussess ? "messageSuccess" : "messageWarning"
        showGlobalMessage({ message: this.reedemMessage, gap, iconClass })
      })
    },
    handleArrowChange(item) {
      if (item.isExpand) {
        this.detailVisible = true
        this.expandItem = item
      }
      console.log("handleArrowChange", item)
    },
    handleDetailClose() {
      this.detailVisible = false
      this.expandItem.isExpand = false
    },
    trackCouponClickEvent(item) {
      trackCouponClickEvent(item)
    }
  }
}
